import Amber from './amber'
import Blue from './blue'
import Emerald from './emerald'
import Rose from './rose'
import Slate from './slate'
import Teal from './teal'
import Violet from './violet'

export const themes = [Amber, Blue, Emerald, Rose, Slate, Teal, Violet]
